"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getRecentPausedTime_1 = __importDefault(require("./getRecentPausedTime"));
const hasPausedSinceClaw_1 = __importDefault(require("./hasPausedSinceClaw"));
const isClawOnCooldown = () => {
    if (state_1.default.hasRecentDestruction()) {
        let amount = state_1.default.currentTime - state_1.default.recentDestruction.clawedAt;
        if ((0, hasPausedSinceClaw_1.default)()) {
            amount -= (0, getRecentPausedTime_1.default)();
        }
        return amount < 1000;
    }
    return false;
};
exports.default = isClawOnCooldown;
